"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = require("../Box");

var _baseStyle = require("../shared/baseStyle");

var _useCustomStyles = require("../utils/useCustomStyles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Image = _styledComponents.default.img.withConfig({
  displayName: "Image",
  componentId: "ghrhaw-0"
})(["", " ", " ", ""], _baseStyle.baseStyle, _Box.layoutInterpolationFn, (0, _useCustomStyles.getCustomStyles)('image.styles', 'root'));

exports.Image = Image;